import type { MigrationStrategies } from 'rxdb';
import type { WorkPackagesDocument } from './workPackages.types';

export const workPackagesMigrationStrategies: MigrationStrategies = {
  1: (oldDoc: WorkPackagesDocument) => ({ ...oldDoc, isAdhoc: false }),
};
